import { Button as Btn, ButtonProps } from '@mis/sushi-tailwind-react';
import * as React from 'react';
import AddButton from './add-button/AddButton';
import CollapseButton from './collapse-button/CollapseButton';
import { DeleteButton } from './delete-button/DeleteButton';
import { GreenButton } from './green-button/GreenButton';
import { LinkButton } from './link-button/LinkButton';
import { PrimaryButton } from './primary-button/PrimaryButton';
import { RedButton } from './red-button/RedButton';
import { SecondaryButton } from './secondary-button/SecondaryButton';
import { TransparentButton } from './transparent-button/TransparentButton';

interface OverrideButtonInterface extends React.FC<ButtonProps> {
  Primary: typeof PrimaryButton;
  Secondary: typeof SecondaryButton;
  Green: typeof GreenButton;
  Red: typeof RedButton;
  Transparent: typeof TransparentButton;
  Add: typeof AddButton;
  Delete: typeof DeleteButton;
  Link: typeof LinkButton;
  Collapse: typeof CollapseButton;
}

const Button: OverrideButtonInterface = (props) => {
  return <Btn type="button" {...props} />;
};

Button.displayName = 'OverrideButton';
Button.Primary = PrimaryButton;
Button.Secondary = SecondaryButton;
Button.Green = GreenButton;
Button.Red = RedButton;
Button.Transparent = TransparentButton;
Button.Add = AddButton;
Button.Delete = DeleteButton;
Button.Link = LinkButton;
Button.Collapse = CollapseButton;

export default Button;
